<div class="kwrap" [class.hero]="size === 'hero'">
  <div class="kmain">
    <div class="kv">{{ value }}<small *ngIf="suffix"> {{ suffix }}</small></div>
    <div class="kd" *ngIf="deltaText">{{ deltaText }}</div>
    <div class="kchip" [ngClass]="'chip-' + statusChip.status" *ngIf="statusChip">
      <nb-icon [icon]="chipIcon(statusChip.status)" aria-hidden="true"></nb-icon>
      <span>{{ statusChip.labelKey | translate }}</span>
    </div>
    <div class="kbullet" *ngIf="bullet">
      <div class="kchip" [ngClass]="'chip-' + chip.status" *ngIf="bulletChip as chip">
        <nb-icon [icon]="chipIcon(chip.status)" aria-hidden="true"></nb-icon>
        <span>{{ chip.labelKey | translate }}</span>
      </div>
      <div class="track" [attr.aria-label]="ragLabelKey() | translate" [title]="ragLabelKey() | translate"><i [style.width.%]="bulletWidthPct"></i><em *ngIf="bullet.target !== null" [style.left.%]="bulletTargetPct"></em></div>
    </div>
  </div>
  <div class="kspark" *ngIf="sparkOptions" echarts [options]="sparkOptions"></div>
</div>
